import { IFilter } from '../../types/filters';
import { PublicationDateContainer } from '../../containers/advancedFilters/PublicationDateContainer';

export const publicationDate: IFilter = {
  component: PublicationDateContainer,
};
